// src/content.js
//
// Built-in copy. ContentContext merges whatever has been edited in the portal
// over this on mount, so the page renders instantly and survives an
// unreachable API. Same pattern as the Cold Storage and Maintenance sites.

export const DEFAULTS = {
  hero: {
    heading: "Refurbished commercial equipment, ready to run",
    body: "Pre-owned commercial refrigeration from Brooke. Browse what is on the floor, ask about any unit, and the office will come back to you with the details.",
  },

  how: {
    eyebrow: "How it works",
    heading: "From the listing to your floor",
    steps: [
      {
        title: "Browse",
        body: "Everything listed here is available now. Sold units come off the page as soon as they go.",
      },
      {
        title: "Ask about a unit",
        body: "Send an enquiry from any listing and it reaches the office with the unit already attached.",
      },
      {
        title: "Collect or arrange delivery",
        body: "The office confirms condition, price and how the unit gets to you.",
      },
    ],
  },

  contact: {
    phoneLabel: "078 220 5037",
    phone: "+27782205037",
    street: "34 Joan Road, Winternest AH",
    locality: "Akasia",
    region: "Gauteng",
    postal: "0200",
  },

  // General enquiries only. An enquiry from a listing carries the unit itself
  // as its subject, so it never uses this list.
  enquirySubjects: [
    { ref: "looking-for", label: "Looking for specific equipment" },
    { ref: "other", label: "Something else" },
  ],
};

// Not editable. Where this site sits in the estate.
export const SITE = {
  division: "Division 03",
  name: "Brooke Requip",
  gateway: "https://brookerefrigeration.co.za",
  siblings: [
    { label: "Maintenance", href: "https://maintenance.brookerefrigeration.com" },
    { label: "Cold Storage", href: "https://coldstorage.brookerefrigeration.com" },
  ],
};
